import { ServiceSpecification } from '@service_specification/specification_commonjs/stailer_service_specification/v1/service_specification_pb'
import { ContactManagementType } from '@service_specification/specification_commonjs/stailer_service_specification/customer_support/v1/customer_support_pb'

export function createPartnerConfigFeatureFlagsCustomerSupportPart(spec: ServiceSpecification) {
  return {
    get contactManagementType(): 'viewOnly' | 'statusControl' {
      if (spec.customerSupport?.contactManagementType === ContactManagementType.STATUS_CONTROL) {
        return 'statusControl'
      }
      return 'viewOnly'
    },
  }
}
